import axios from "./AxiosInstance"
const GetPatientGoals = (userId) => {
    let url = `api/goals`
    if (userId) {
        url += `?patientId=${userId}`
    }

    return axios.get(url)
}

const GetGoals = () => axios.get("api/objectif")

const update = (goalId, data) => axios.put(`api/goals/${goalId}`, { ...data })

export const GoalService = {
    GetPatientGoals,
    update,
    GetGoals
}
